<template>
  <div class="base-password-form-item">
    <slot name="default" :label="label">
      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ label }}</label>
    </slot>
    <el-form-item :prop="finalName" :rules="finalRules">
      <el-input clearable show-password :autocomplete="autocomplete" :placeholder="placeholder" type="password"
        class="w-full" v-model="localValue" maxlength='50' :disabled="disabled" v-popover:popoverrepeat
        v-on="$listeners">
        <i v-if="icon" slot="prefix" class="el-input__icon">
          <base-icon size="sm" :name="icon" />
        </i>
      </el-input>
    </el-form-item>
    <el-popover ref="popoverrepeat" placement="top-start" :title="$t('validation.popup.title')" width="380"
      trigger="focus" popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200">
      <div>
        <div><base-icon-pass-validation :validated="validation.numChar" />{{ $t('validation.popup.num_char') }}</div>
        <div><base-icon-pass-validation :validated="validation.numMin" />{{ $t('validation.popup.num_min') }}</div>
        <div><base-icon-pass-validation :validated="validation.charMinus" />{{ $t('validation.popup.char_minus') }}</div>
        <div><base-icon-pass-validation :validated="validation.charMayus" />{{ $t('validation.popup.char_mayus') }}</div>
        <div><base-icon-pass-validation :validated="validation.especial" />{{ $t('validation.popup.especial') }}</div>
        <div v-if="repeat"><base-icon-pass-validation
            :validated="validation.passRepeat" />{{ $t('validation.popup.pass_repeat') }}</div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
export default {
  name: 'base-password-form-item',
  props: {
    value: {
      type: [String],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    repeat: {
      type: Boolean,
      default: false,
    },
    password: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      localValue: this.value,
      validation: {
        numChar: false,
        numMin: false,
        charMinus: false,
        charMayus: false,
        especial: false,
        passRepeat: !this.repeat
      },
      rules: [
        {
          required: true,
          message: i18n.t('validation.complete'),
          trigger: 'blur'
        },
        { validator: (rule, value, callback) => this.isPasswordValid(rule, value, callback, { validation: this.validation }), trigger: 'blur' }, // Mixin
        { validator: (rule, value, callback) => this.isPasswordValid(rule, value, callback, { validation: this.validation }), trigger: 'change' } // Mixin
      ],
      repeatRules: [
        {
          required: true,
          message: i18n.t('validation.complete'),
          trigger: 'blur'
        },
        { validator: (rule, value, callback) => this.isRepeatPasswordValid(rule, value, callback, { validationRepeat: this.validation, checkPassword: this.password }), trigger: 'blur' }, // Mixin
        { validator: (rule, value, callback) => this.isRepeatPasswordValid(rule, value, callback, { validationRepeat: this.validation, checkPassword: this.password }), trigger: 'change' } // Mixin
      ],
    }
  },
  computed: {
    finalName: function () {
      return this.name || `${this.repeat ? 'repeat_' : ''}password`
    },
    label: function () {
      return this.repeat ? i18n.t('configurations.repeat_password') : i18n.t('users.password')
    },
    finalRules: function () {
      if (this.repeat) {
        return this.repeatRules
      }
      return this.rules
    },
  },
  watch: {
    repeat: function (value, oldValue) {
      this.validation.passRepeat = !value || this.value === this.password
    },
    value: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
    localValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('input', value)
      }
    }
  },
}
</script>
